import { render, staticRenderFns } from "./SelectionDivs.vue?vue&type=template&id=6d484122"
import script from "./SelectionDivs.vue?vue&type=script&lang=js"
export * from "./SelectionDivs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports